import { IMoveToState } from './types';

export const moveToReducer = (
    moveToState: IMoveToState,
    update: IMoveToState
): IMoveToState => ({
    ...moveToState,
    ...update
});
